module.exports = __webpack_public_path__ + "static/img/index_wenhua2.6d45d0c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/index_wenhua2.jpg
// module id = 75Ei
// module chunks = 1